import {Trans} from '@lingui/macro'

import {Accordion} from '~/generic-ui/accordion'

import {StyledAccordionContent, StyledAccordionItem, StyledHeader, Title} from '../components'

interface ProTipsItemProps {
    children: React.ReactNode // Guide content (e.g. <ExportContent/>)
}

const ProTipsItem = ({children}: ProTipsItemProps) => {
    return (
        <StyledAccordionItem value={ProTipsItem.accordionItemId}>
            <StyledHeader>
                <Title>
                    <Trans>Pro tips</Trans>
                </Title>
                <Accordion.Chevron />
            </StyledHeader>
            <StyledAccordionContent>{children}</StyledAccordionContent>
        </StyledAccordionItem>
    )
}

// Used to identify currently open accordion item
ProTipsItem.accordionItemId = 'PRO_TIPS'

export default ProTipsItem
